<template>
  <div v-if="new_image || image">
    <Logo
      v-if="$utils.extractUrl(image?.props?.component_props?.url, $route) == 'N/A' && !new_image"
      class="h-24 w-24 absolute ml-5 -mt-28" />
    <img
      v-else
      class="inline-block border rounded-md h-24 max-w-[800px] absolute ml-5 -mt-28"
      :src="new_image?.src || $utils.extractUrl(image?.props?.component_props?.url, $route)"
      alt="">
  </div>
  <div class="flex gap-x-2 mb-10 mt-32 items-center">
    <button class="btn cancel-btn h-10 w-32">
      {{ new_image || image ? $t("Change Image") : $t("Add New Image") }}
    </button>
    <input
      name="file-upload"
      accept="image/*"
      type="file"
      placeholder="here"
      class="custom-file-input w-32 h-10 cursor-pointer border"
      @change="(e) => addFiles(e)">

    <div class="ml-10 flex items-start space-x-3">
      <div class="dark:text-white mt-2">
        {{ $t("Background") }}:
      </div>
      <div class="relative flex flex-col mt-1 items-center justify-center dark:border-dark-divider-border">
        <ColorPickerList v-model:current-item="image_bg_color" />
      </div>
    </div>

    <label v-if="$route.name == 'CompanyProfile' || $route.name == 'ObjectProfile'" class="mt-1.5 ml-4">{{ $t("Show on") }}:</label>
    <SelectInput
      v-if="$route.name == 'CompanyProfile' || $route.name == 'ObjectProfile'"
      v-model="connect_to"
      :disabled="disabled_connect_to_selection"
      name="select_input"
      :allow-null="false"
      :items="connect_to_options"
      :is-box-background="true"
      :value="connect_to"
      label-attr="name"
      value-attr="value"
      :placeholder="$t('Connect to')"
      :label="$t('Connect to')"
      class="w-[200px]"
      input-classes="appearance-none text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm" />
  </div>

  <div class="flex flex-row justify-between w-full gap-2">
    <div class="w-1/2 m-0 cancel-btn" @click="is_loading ? null : $emit('cancel')">
      {{ $t("Cancel") }}
    </div>
    <button
      :class="[!new_image && !bg_color_updated ? 'opacity-50' : '']"
      :disabled="!new_image && !bg_color_updated"
      type="button"
      class="w-1/2 primary-btn"
      @click="updateImage()">
      {{ is_loading ? $t("Loading...") : image ? $t("Update Image") : $t("Create Image") }}
    </button>
  </div>
</template>

<script>
import SelectInput from "@/components/shared/SelectInput.vue"
import Logo from "@/components/shared/Logo.vue"
import ColorPickerList from "@/components/shared/ColorPickerList.vue"

const maxFileAllowedSizeMB = 20
const maxFileAllowedSize = maxFileAllowedSizeMB * 1024 * 1024
export default {
  components: { SelectInput, Logo, ColorPickerList },
  props: { image: null },
  emits: ["setComponentData", "cancel", "submitForm"],
  data() {
    return {
      new_attachments: [],
      new_image: null,
      is_loading: false,
      connect_to: "all_pages",
      connect_to_options: [
        { name: this.$t("All Pages"), value: "all_pages" },
        { name: this.$t("This Page"), value: "this_page" }
      ],
      image_bg_color: "",
      page_identifier: "all",
      disabled_connect_to_selection: false,
      bg_color_updated: false
    }
  },

  watch: {
    connect_to() {
      if (this.connect_to == "this_page") {
        this.page_identifier = `${this.$route.params.object_type}>${this.$route.params.cid}`
      } else {
        this.page_identifier = "all"
      }
      this.setComponentData()
    },
    image_bg_color() {
      this.bg_color_updated = true
      this.setComponentData()
    }
  },

  created() {
    if (this.image) {
      this.disabled_connect_to_selection = true
      if (typeof this.image.props.component_props.label == "object") {
        this.connect_to = "this_page"
      }
      this.image_bg_color = this.image.props.component_props.backgroundColor
    }
  },

  methods: {
    setComponentData() {
      this.$emit("setComponentData", {
        required_filled: this.new_attachments.length,
        attachments: this.new_attachments,
        backgroundColor: this.image_bg_color,
        connectTo: this.connect_to,
        page_identifier: this.page_identifier
      })
    },
    addFiles(event) {
      Array.from(event.target.files).map((file) => {
        if (file.size < maxFileAllowedSize) {
          this.$utils.replaceOrAddItem(this.new_attachments, { name: file.name, file: file }, "name")
          const image = document.createElement("img")
          image.src = URL.createObjectURL(file)
          this.new_image = image
          this.setComponentData()
        }
      })
    },
    updateImage() {
      this.$emit("submitForm", {
        id: this.image?.id,
        attachments: this.new_attachments,
        backgroundColor: this.image_bg_color,
        component_type: "image",
        connectTo: this.connect_to,
        page_identifier: this.page_identifier
      })
    }
  }
}
</script>

<style scoped>
.rainbow-bg {
  background: conic-gradient(red, yellow, lime, aqua, blue, magenta, red);
}
</style>
